import { useState, useCallback } from "react";
import { toast } from "sonner";
import { createPropVidApi, ListPropVidsApi, DeletePropVidApi } from "../../services/allAPI";

export const usePropertyVideos = (propertyId) => {
    const [videos, setVideos] = useState([]);
    const [loading, setLoading] = useState(false);

    const fetchVideos = useCallback(async () => {
        if (!propertyId) return;
        setLoading(true);
        try {
            const res = await ListPropVidsApi(propertyId);
            // console.log("videos response:", res.data);
            setVideos(res.data || []);
        } catch (err) {
            console.error("Error in video fetching");
        } finally {
            setLoading(false);
        }
    }, [propertyId]);

    const addVideo = async (file) => {
        try {
            const formData = new FormData();
            formData.append("video", file);
            const res = await createPropVidApi(propertyId, formData);
            setVideos((prev) => [...prev, res.data]);
            toast.success("Video uploaded successfully");
            return res.data;
        } catch (err) {
            toast.error("Failed to upload video");
            throw err;
        }
    };

    const deleteVideo = async (videoId) => {
        try {
            await DeletePropVidApi(propertyId, videoId);
            setVideos((prev) => prev.filter((vid) => vid.id !== videoId));
            toast.success("Video deleted");
        } catch (err) {
            toast.error("Failed to delete video");
            throw err;
        }
    };

    return { videos, loading, fetchVideos, addVideo, deleteVideo };
};